import React from 'react';
import { useTranslation } from 'react-i18next';

import BarTabs from './BarTabs/BarTabs';
import ByLine from './ByLine/ByLine';
import ByDestination from './ByDestination/ByDestination';
import MSelect from 'app/ui/MSelect/MSelect';

import { OrderType } from 'app/enums/order-types';

import classes from './ReservationBar.module.scss';
import { condClass, serialArray } from 'app/utils/general';
import { SearchType } from './ReservationBar.model';
import { ByLineForm } from './ByLine/ByLine.model';
import { DestinationForm } from './ByDestination/ByDestination.model';
import { IShuttle } from 'app/models/shuttle';

interface Props {
  className?: string;
  maxPassengers: number;
  passengersCount: number;
  onPassengerCount: (value: number) => void;
  initialValuesDestination?: DestinationForm | null;
  orderTypeState: OrderType | null;
  returnDateVisibility: boolean;
  selectedShuttleSearchType: SearchType | null;
  shuttleSearchType: SearchType[] | null;
  searchTypesVisible: boolean;
  onSubmitDestination: (values: DestinationForm) => void;
  onSubmitLine: (values: ByLineForm, shuttleType: 'simple' | 'fixable', shuttle: IShuttle) => void;
  onSelectedTab: (tab: OrderType) => void;
  onSelectAutoCompleteType: (type: SearchType) => void;
  isDisabled: boolean;
}

const ReservationBarView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <div className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
      {props.isDisabled && <div className={classes['disabled-conatiner']}></div>}
      <BarTabs orderType={props.orderTypeState} onSelectedBarTab={props.onSelectedTab}></BarTabs>
      <div className={classes['autoCompleteTypes']}>
        {props.searchTypesVisible ? (
          <div className={classes['searchType']}>
            {Object.values(SearchType).map((type: SearchType) => {
              return (
                <button
                  key={type}
                  type="button"
                  onClick={() => props.onSelectAutoCompleteType(type)}
                  className={condClass({
                    [classes['btn']]: true,
                    [classes['selected']]: type === props.selectedShuttleSearchType,
                    [classes['hide']]: !props.shuttleSearchType?.includes(type),
                  })}
                >
                  {t(`reservationBar.autoCompleteType.${type}`)}
                </button>
              );
            })}
          </div>
        ) : null}
        <div className={classes['passengers']}>
          <MSelect value={props.passengersCount} onChange={(value: number) => props.onPassengerCount(value)} className={classes['input']}>
            {serialArray(props.maxPassengers, false).map((i: number) => (
              <option key={i} value={i}>
                {i} {i === 1 ? t('reservationBar.passenger') : t('reservationBar.passengers')}
              </option>
            ))}
          </MSelect>
        </div>
      </div>
      {props.selectedShuttleSearchType === SearchType.Destination ? (
        props.shuttleSearchType?.includes(SearchType.Destination) ? (
          <ByDestination
            passengers={props.passengersCount}
            initialValues={props.initialValuesDestination}
            onSubmit={props.onSubmitDestination}
            returnDateVisibility={props.returnDateVisibility}
          ></ByDestination>
        ) : null
      ) : props.selectedShuttleSearchType === SearchType.Line ? (
        props.shuttleSearchType?.includes(SearchType.Line) ? (
          <ByLine passengers={props.passengersCount} onSubmit={props.onSubmitLine}></ByLine>
        ) : null
      ) : null}
    </div>
  );
};

ReservationBarView.displayName = 'ReservationBarView';
ReservationBarView.defaultProps = {};

export default ReservationBarView;
